import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./index.css";

import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Toaster } from "react-hot-toast";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <App />
        <Toaster
          position="top-center"
          toastOptions={{
            duration: 3000,
            style: {
              fontSize: "13px",
              fontFamily: "Figtree, system-ui, sans-serif",
              fontWeight: 400,
              borderRadius: "6px",
              border: "1px solid var(--tb-toast-border)",
              background: "var(--tb-toast-bg)",
              color: "var(--tb-ink)",
              boxShadow: "0 4px 16px rgba(15,23,42,0.08)",
            },
            success: {
              iconTheme: { primary: "#0f766e", secondary: "#fff" },
            },
          }}
        />
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
